import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';
import { Http } from '@angular/http';
import { WindowRefManager } from 'app/shared/services/window.service';

@Injectable()
export class UmbracoService {

    constructor(private http: Http,
                private windowManager: WindowRefManager) { }

    public GetPropertyName(property: string): string {
        return this.windowManager.nativeWindow.umbraco[property];
    }

    public GetPropertyValue(property: string) {
        const pageNodeId = this.GetPropertyName(Property.PageNodeId);
        return this.http.get(`umbraco/Surface/Umbraco/GetContent?nodeId=` + pageNodeId + `&propertyName=` + property, null);
    }
}


export class Property {
    public static PageNodeId = 'pageNodeId';
    public static PageTitle = 'pageTitle';
}




// WEBPACK FOOTER //
// ./src/app/shared/services/umbraco.service.ts